import { Action, createReducer, on } from "@ngrx/store";
import { FuelingModeDTO } from "src/app/models/fueling-mode/fueling-modeDTO";
import * as FuelingModesActionTypes from "../../actions/fueling-modes/fueling-modes.actions";

export interface FuelingModeState {
  fuelingModeList?: FuelingModeDTO[];
  fuelingModeExcelList?: FuelingModeDTO[];
  totalFuelingMode?: number;
  fuelingMode?: FuelingModeDTO;
  isLoading?: boolean;
  created?: boolean;
  error?: boolean;
  fuelingModeTableConfig: any;
}

export const initialState: FuelingModeState = {
  created: null,
  error: null,
  fuelingMode: null,
  fuelingModeExcelList: null,
  fuelingModeList: null,
  isLoading: false,
  totalFuelingMode: null,
  fuelingModeTableConfig: null,
};

const fuelingModeReducer = createReducer(
  initialState,
  on(FuelingModesActionTypes.resetFuelingModesState, () => initialState),
  on(
    FuelingModesActionTypes.getFuelingModes,
    (state, { options }) =>
      ({
        ...state,
        isLoading: true,
        options: options,
        error: null,
      } as FuelingModeState)
  ),
  on(FuelingModesActionTypes.loadFuelingModes, (state, { response }) => {
    return {
      ...state,
      fuelingModeList: (response as any).result?.items
        ? (response as any).result?.items
        : [],
      error: null,
      isLoading: false,
      totalFuelingMode: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
    };
  }),
  on(
    FuelingModesActionTypes.getFuelingModesExcel,
    (state, { options }) =>
      ({
        ...state,
        isLoading: true,
        options: options,
        error: null,
      } as FuelingModeState)
  ),
  on(FuelingModesActionTypes.loadFuelingModesExcel, (state, { response }) => {
    return {
      ...state,
      fuelingModeExcelList: (response as any).result?.items
        ? (response as any).result?.items
        : [],
      error: null,
      isLoading: false,
    };
  }),
  on(
    FuelingModesActionTypes.getFuelingMode,
    (state, { code }) =>
      ({
        ...state,
        isLoading: true,
        code: code,
        error: null,
        created: false,
      } as FuelingModeState)
  ),
  on(FuelingModesActionTypes.loadFuelingMode, (state, { response }) => {
    return {
      ...state,
      fuelingMode: (response as any).result
        ? (response as any).result
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(FuelingModesActionTypes.loadFuelingModesLoadStart, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(FuelingModesActionTypes.loadFuelingModesLoadEnd, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),
  on(FuelingModesActionTypes.resetFuelingMode, (state) => {
    return {
      ...state,
      fuelingMode: null,
      error: null,
    };
  }),

  on(
    FuelingModesActionTypes.loadFuelingModesTableConfig,
    (state, { response }) => {
      return {
        ...state,
        fuelingModeTableConfig:
          (response as any)?.result?.value?.tableColumnInfo ?? undefined,
      };
    }
  ),
  on(FuelingModesActionTypes.resetCreation, (state) => {
    return {
      ...state,
      created: true,
    };
  }),
  on(
    FuelingModesActionTypes.createFuelingMode,
    FuelingModesActionTypes.updateFuelingModes,
    FuelingModesActionTypes.saveFuelingModesTableConfig,
    FuelingModesActionTypes.getFuelingModesTableConfig,
    (state) => {
      return {
        ...state,
        isLoading: true,
      };
    }
  )
);

export function reducer(state: FuelingModeState | undefined, action: Action) {
  return fuelingModeReducer(state, action);
}
